import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "deposit_details"
};
const _hoisted_2 = {
  class: "base_details_content"
};
const _hoisted_3 = {
  key: 0,
  class: "content",
  style: {
    "margin-top": "20px"
  }
};
const _hoisted_4 = {
  key: 1,
  class: "content"
};
const _hoisted_5 = {
  class: "base_details_content_second"
};
const _hoisted_6 = {
  class: "base_details_content"
};
const _hoisted_7 = {
  class: "content"
};

const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "支付明细", -1);

const _hoisted_9 = {
  class: "base_details_content_second"
};

const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "关联订单", -1);

const _hoisted_11 = {
  class: "base_details_content_second"
};

const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "产品信息", -1);

const _hoisted_13 = {
  class: "base_details_content_second"
};
const _hoisted_14 = ["src"];
import { ref, reactive } from "vue";
import $ from "@util/base";
import { $msg, $box } from "@/common/ui/msg";
import BackTitleView from "@com/BackTitleView.vue";
import useRoute from "@util/router";
import api from "@api/points";
export default {
  __name: 'PointsDetails',

  setup(__props) {
    const route = useRoute();
    const urlQuery = route.query();
    route.watchRouter("pointsdetails", () => {
      getData();
    });
    var isApproval = false;
    $.handleCRU(urlQuery.type, {
      show: () => {
        getData();
      },
      examine: () => {
        isApproval = true;
        getData();
      }
    });
    const data = ref([{}]);
    const data1 = ref([{
      list: [],
      payList: [],
      productList: []
    }]);
    const relationConfig = [{
      label: "订单编号",
      prop: "orderCode"
    }, {
      label: "发货方式",
      prop: "deliveryType",
      width: 100
    }, {
      label: "归属基地",
      prop: "shopName",
      width: 140
    }, {
      label: "下单时间",
      prop: "createTime"
    }, {
      label: "付款时间",
      prop: "payTime"
    }, {
      label: "活动优惠",
      prop: "discountMoney"
    }, {
      label: "实付金额",
      prop: "dueMoney"
    }];
    const total = ref(0);
    const config = {
      showIndex: true,
      column: [{
        label: "用户手机号",
        prop: "phone"
      }, {
        label: "积分",
        prop: "integral"
      }, {
        label: "说明",
        prop: "changeReason"
      }, {
        label: "备注",
        prop: "remark"
      }]
    };

    function getData() {
      let routeQuery = route.query();
      api.details(routeQuery.code, routeQuery.batch, routeQuery.p, routeQuery.s, val => {
        total.value = val.total;
        data.value = val.itemList.map(e => {
          if (e.integral > 0) {
            e.integral = `+${e.integral}`;
          }

          return e;
        });
        data1.value = val.payList.map(e => {
          switch (e.payType) {
            case "1021001":
              e.payTypeStr = "微信支付";
              break;

            case "1021002":
              e.payTypeStr = "储值支付";
              break;
          }

          e.payMoney = e.payMoney + "¥";
          return e;
        });
        data1.value = val.list.map(e => {
          // 1017001 商品订单、1017002 旅行订单、1017003 酒店订单、1017004 礼包订单
          switch (e.mainBusiType) {
            case "1017001":
              e.mainBusiType = "商品";
              break;

            case "1017002":
              e.mainBusiType = "旅行";
              break;

            case "1017003":
              e.mainBusiType = "酒店";
              break;

            case "1017004":
              e.mainBusiType = "综合活动";
              break;
          } // 1019001 快递配送、1019002 用户自提


          switch (e.deliveryType) {
            case "1019001":
              e.deliveryType = "快递配送";
              break;

            case "1019002":
              e.deliveryType = "用户自提";
              break;
          }

          return e;
        });
        data1.value = val;
        console.log(data1);
      });
    } // 审批通过


    function approvalPass() {
      $box.open("通过", "确认该积分审批通过", () => {
        api.approval(data.value[0].flowCode, "1007004", "", () => {
          $msg.succ("审批成功");
          route.go(-1);
        });
      });
    } // 驳回


    function approvalRefusal() {
      console.log(data.value);
      $box.input("确认驳回", "驳回原因", null, val => {
        api.approval(data.value[0].flowCode, "1007003", val, () => {
          $msg.succ("驳回成功");
          route.go(-1);
        });
      });
    }

    function back() {
      route.go(-1);
    }

    return (_ctx, _cache) => {
      const _component_DataCollectTable = _resolveComponent("DataCollectTable");

      const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");

      const _component_el_descriptions = _resolveComponent("el-descriptions");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_footer = _resolveComponent("el-footer");

      const _component_el_container = _resolveComponent("el-container");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
        class: "base_details_container"
      }, {
        default: _withCtx(() => [_createVNode(BackTitleView, {
          title: "积分详情"
        }), _createVNode(_component_el_main, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_unref(isApproval) ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_DataCollectTable, {
            data: data.value,
            total: total.value,
            config: config
          }, null, 8, ["data", "total"])])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_descriptions, {
            column: 1,
            class: "base_descriptions_one"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
              label: "用户手机号"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value[0].phone), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "积分"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value[0].integral), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "说明"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value[0].changeReason), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "备注"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value[0].remark), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "审批单号"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value[0].flowCode), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "审批状态"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value[0].flowStatusName), 1)]),
              _: 1
            })]),
            _: 1
          })])]))])]),
          _: 1
        }), _createVNode(_component_el_main, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_table, {
            data: data1.value.payList,
            border: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              prop: "transactionNo",
              label: "交易号",
              width: ""
            }), _createVNode(_component_el_table_column, {
              prop: "payMoney",
              label: "金额",
              width: "100"
            }), _createVNode(_component_el_table_column, {
              prop: "payTypeStr",
              label: "支付方式",
              width: "100"
            }), _createVNode(_component_el_table_column, {
              prop: "payTime",
              label: "交易时间",
              width: "180"
            })]),
            _: 1
          }, 8, ["data"])]), _hoisted_10, _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_table, {
            data: data1.value.list,
            border: ""
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(relationConfig, (item, index) => {
              return _createVNode(_component_el_table_column, {
                key: index,
                prop: item.prop,
                label: item.label,
                width: item.width
              }, null, 8, ["prop", "label", "width"]);
            }), 64))]),
            _: 1
          }, 8, ["data"])]), _hoisted_12, _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_table, {
            data: data1.value.productList,
            border: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              label: "产品图片",
              width: "110",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("img", {
                src: scope.row.picUrl,
                style: {
                  width: '75px',
                  height: '75px'
                }
              }, null, 8, _hoisted_14)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              prop: "productName",
              label: "产品名称"
            }), _createVNode(_component_el_table_column, {
              prop: "skuName",
              label: "规格",
              width: "80"
            }), _createVNode(_component_el_table_column, {
              prop: "shopName",
              label: "归属基地",
              width: "140"
            }), _createVNode(_component_el_table_column, {
              prop: "duePrice",
              label: "价格",
              width: "80"
            }), _createVNode(_component_el_table_column, {
              prop: "num",
              label: "数量",
              width: "60"
            }), _createVNode(_component_el_table_column, {
              prop: "profitMoney",
              label: "毛利",
              width: "100"
            }), _createVNode(_component_el_table_column, {
              prop: "profitRate",
              label: "毛利率%",
              width: "100"
            })]),
            _: 1
          }, 8, ["data"])])])])]),
          _: 1
        }), _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [_unref(isApproval) ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: approvalPass,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("审批通过")]),
            _: 1
          }, 512)), [[_vShow, data.value[0].flowStatus == '1007002']]) : _createCommentVNode("", true), _unref(isApproval) ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            onClick: approvalRefusal,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("审批驳回")]),
            _: 1
          }, 512)), [[_vShow, data.value[0].flowStatus == '1007002']]) : _createCommentVNode("", true), _createVNode(_component_el_button, {
            onClick: back
          }, {
            default: _withCtx(() => [_createTextVNode("关闭")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }

};